export const getCacheBuster = () => Math.round(Math.random() * Date.now());
